import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface FormaPagamentoFiscal {
    id: number
    descricao: string
    selecionada: boolean
}

export interface ConfiguracaoFiscalData {
    emissaoAutomatica: boolean
    cnpjPlugNotas: string | null
    tipoEmissao: string
    limiteDiario: number | null
    emailsFechamentoFiscal: string | null
    regimeTributario?: string
    cfopProducaoPropria?: string
    cfopRevenda?: string
    csosnProducaoPropria?: string
    csosnRevenda?: string
    emissoesHoje: number
    valorEmitidoHoje?: number
    formas: FormaPagamentoFiscal[]
}

export interface SalvarConfiguracaoFiscalPayload {
    emissaoAutomatica: boolean
    cnpjPlugNotas: string | null
    tipoEmissao: string
    limiteDiario: number | null
    emailsFechamentoFiscal: string | null
    regimeTributario: string
    cfopProducaoPropria: string
    cfopRevenda: string
    csosnProducaoPropria: string
    csosnRevenda: string
    idsSelecionados: number[]
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterConfiguracaoFiscal = async function (
    authorization: string
): Promise<ConfiguracaoFiscalData | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ConfiguracaoFiscalData>>("notafiscal/ObterConfiguracaoFiscal", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ConfiguracaoFiscalData>(response, "ObterConfiguracaoFiscal")
    } catch (error) {
        RegistrarLogErro(error, "ObterConfiguracaoFiscal", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarConfiguracaoFiscal = async function (
    authorization: string,
    payload: SalvarConfiguracaoFiscalPayload
): Promise<{ mensagem: string } | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<{ mensagem: string }>>(
                "notafiscal/SalvarConfiguracaoFiscal",
                payload,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ mensagem: string }>(response, "SalvarConfiguracaoFiscal")
    } catch (error) {
        RegistrarLogErro(error, "SalvarConfiguracaoFiscal", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
